import { useCallback } from 'react';
import { WorkbookReview } from './WorkbookReview';
import type { WorkbookSheetPlan } from '../lib/api';

export function ImportFileReview({ file, onPlans }: { file: File; onPlans: (file: File, plans: WorkbookSheetPlan[] | null) => void }) {
  const change = useCallback((plans: WorkbookSheetPlan[] | null) => onPlans(file, plans), [file, onPlans]);
  return <WorkbookReview file={file} onChange={change} />;
}
